import React, { useState } from "react";
import { Table, Button, InputNumber, Alert, Row, Col, Card } from "antd";
import { CheckCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import BackHome from "../components/BackHome";
import { BASE_URL } from "../constants/Url";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const CartShopPage = () => {
  const [quantity, setQuantity] = useState(1);
   const { t } = useTranslation();
  const navigate = useNavigate();
  const price = 90.0;
  const total = price * quantity;

  const columns = [
    {
      title: "",
      dataIndex: "action",
      render: (_, record) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => console.log("Remove item")}
        />
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => (
        <Row align="middle">
          <img
            src={BASE_URL + "/about-us/bestSeller.jpg"}
            alt="shirt"
            style={{ width: 60, height: 60, marginRight: 10 }}
          />
          <span>{text}</span>
        </Row>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (value) => <span style={{ color: "green" }}>${value.toFixed(2)}</span>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      render: () => (
        <InputNumber
          min={1}
          value={quantity}
          onChange={(value) => setQuantity(value)}
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "total",
      render: () => <span style={{ color: "green" }}>${total.toFixed(2)}</span>,
    },
  ];

  const data = [
    {
      key: "1",
      product: "Man's Shirt long sleeve",
      price: price,
      quantity: quantity,
    },
  ];
  const handleAddCheckout = (item) => {
        navigate(`/checkout`);
    }

  return (
    <>
      <BackHome title="Cart" t={t}/>
      <div className='esi-white-space'></div>
      <div className="esi-std-container pb-5">
        {/* Success Alert */}
        <Alert
          message={
            <>
              <CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />
              “Man’s Shirt long sleeve” has been added to your cart.
            </>
          }
          type="success"
          showIcon={false}
          style={{ marginBottom: 20 }}
        />

        {/* Cart Table */}
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          footer={() => (
            <Row justify="end" style={{ marginTop: 10 }}>
              <Button size="large" type="primary" style={{ marginRight: 10, backgroundColor:"rgb(17, 152, 17)" }}>
                Continue Shopping
              </Button>
              <Button size="large" type="primary" danger>
                Update Cart
              </Button>
            </Row>
          )}
        />

        {/* Cart Totals */}
        <Row justify="end" style={{ marginTop: 40 }}>
          <Col xs={24} sm={12} md={8}>
            <Card
              title="Cart Totals"
              bordered
              style={{ borderColor: "#f0ad4e", borderWidth: 2, paddingBottom:"20px" }}
            >
              <Row justify="space-between">
                <strong>Subtotal</strong>
                <span style={{ color: "green" }}>${total.toFixed(2)}</span>
              </Row>
              <Row justify="space-between" style={{ marginTop: 10 }}>
                <strong>Total</strong>
                <span style={{ color: "green" }}>${total.toFixed(2)}</span>
              </Row>
              <Button
                type="primary"
                size="large"
                block
                style={{ marginTop: 20, backgroundColor: "#000", borderColor: "#000" }}
                onClick={() => handleAddCheckout()}
              >
                Proceed to Checkout
              </Button>
            </Card>
          </Col>
        </Row>
      </div>
      <div className='esi-white-space'></div>
    </>
  );
};

export default CartShopPage;
